/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeeType } from './FeeType';
import {
    FeeTypeFromJSON,
    FeeTypeFromJSONTyped,
    FeeTypeToJSON,
    FeeTypeToJSONTyped,
} from './FeeType';

/**
 * Payload to create or update a claim's financial summary
 * @export
 * @interface UpsertFinancialSummaryRequest
 */
export interface UpsertFinancialSummaryRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertFinancialSummaryRequest
     */
    deductibleCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertFinancialSummaryRequest
     */
    rcvCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertFinancialSummaryRequest
     */
    depreciationCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertFinancialSummaryRequest
     */
    recoverableDepreciationCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertFinancialSummaryRequest
     */
    nonRecoverableDepreciationCents?: number | null;
    /**
     * 
     * @type {FeeType}
     * @memberof UpsertFinancialSummaryRequest
     */
    feeType?: FeeType;
    /**
     * 
     * @type {number}
     * @memberof UpsertFinancialSummaryRequest
     */
    feePercentage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertFinancialSummaryRequest
     */
    flatFeeCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertFinancialSummaryRequest
     */
    acvCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertFinancialSummaryRequest
     */
    netClaimCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertFinancialSummaryRequest
     */
    netWithRecoverableCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertFinancialSummaryRequest
     */
    expectedFeeCents?: number | null;
}



/**
 * Check if a given object implements the UpsertFinancialSummaryRequest interface.
 */
export function instanceOfUpsertFinancialSummaryRequest(value: object): value is UpsertFinancialSummaryRequest {
    return true;
}

export function UpsertFinancialSummaryRequestFromJSON(json: any): UpsertFinancialSummaryRequest {
    return UpsertFinancialSummaryRequestFromJSONTyped(json, false);
}

export function UpsertFinancialSummaryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertFinancialSummaryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'deductibleCents': json['deductibleCents'] == null ? undefined : json['deductibleCents'],
        'rcvCents': json['rcvCents'] == null ? undefined : json['rcvCents'],
        'depreciationCents': json['depreciationCents'] == null ? undefined : json['depreciationCents'],
        'recoverableDepreciationCents': json['recoverableDepreciationCents'] == null ? undefined : json['recoverableDepreciationCents'],
        'nonRecoverableDepreciationCents': json['nonRecoverableDepreciationCents'] == null ? undefined : json['nonRecoverableDepreciationCents'],
        'feeType': json['feeType'] == null ? undefined : FeeTypeFromJSON(json['feeType']),
        'feePercentage': json['feePercentage'] == null ? undefined : json['feePercentage'],
        'flatFeeCents': json['flatFeeCents'] == null ? undefined : json['flatFeeCents'],
        'acvCents': json['acvCents'] == null ? undefined : json['acvCents'],
        'netClaimCents': json['netClaimCents'] == null ? undefined : json['netClaimCents'],
        'netWithRecoverableCents': json['netWithRecoverableCents'] == null ? undefined : json['netWithRecoverableCents'],
        'expectedFeeCents': json['expectedFeeCents'] == null ? undefined : json['expectedFeeCents'],
    };
}

export function UpsertFinancialSummaryRequestToJSON(json: any): UpsertFinancialSummaryRequest {
    return UpsertFinancialSummaryRequestToJSONTyped(json, false);
}

export function UpsertFinancialSummaryRequestToJSONTyped(value?: UpsertFinancialSummaryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deductibleCents': value['deductibleCents'],
        'rcvCents': value['rcvCents'],
        'depreciationCents': value['depreciationCents'],
        'recoverableDepreciationCents': value['recoverableDepreciationCents'],
        'nonRecoverableDepreciationCents': value['nonRecoverableDepreciationCents'],
        'feeType': FeeTypeToJSON(value['feeType']),
        'feePercentage': value['feePercentage'],
        'flatFeeCents': value['flatFeeCents'],
        'acvCents': value['acvCents'],
        'netClaimCents': value['netClaimCents'],
        'netWithRecoverableCents': value['netWithRecoverableCents'],
        'expectedFeeCents': value['expectedFeeCents'],
    };
}

